module.exports = __webpack_public_path__ + "img/_icon_check.fad27ca4.svg";